<template>

    <div id="g_id_onload"
        style="position: fixed; top: 50px; right: 10px; z-index: 1001;"
        data-prompt_parent_id="g_id_onload"
        data-method="one-tap"
        :data-client_id="clientId"
        :data-login_uri="loginUrl">
    </div>

</template>

<script>

export default {

    data() {
        return {
            loginUrl: process.env.VUE_APP_API_URL + '/v1/auth/google',
            clientId: process.env.VUE_APP_GOOGLE_CLIENT_ID,
        }
    },

}

</script>
